import point from "./point";
import grid from "./grid";
import template from "./template";
import task from "./task";

export default { point, grid, template, task }